import type { PaylinkPaymentType } from '@packages/gql/generated/shopping/graphql';
import type { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { PaymentCard } from '../PaymentCards/PaymentCard.client';

interface PaylinkPaymentMethodsProps {
  data: Array<PaylinkPaymentType | null>;
  selectedType?: PaylinkPaymentType;
  onSelect: (paymentType: PaylinkPaymentType) => void;
}

export const PaylinkPaymentMethods: FC<PaylinkPaymentMethodsProps> = ({
  data,
  selectedType,
  onSelect,
}) => {
  if (data === null) {
    return null;
  }

  return (
    <>
      <h2 className="text-size-headline-2xl mt-2 mb-1 pl-2.5">
        <FormattedMessage
          key="PaylinkPaymentMethods.headline-text"
          id="PaylinkPaymentMethods.headline"
          defaultMessage="Wähle deine Zahlungsart"
        />
      </h2>
      <div className="bg-color-grey-light box-border flex w-full flex-row flex-wrap items-start justify-around gap-2 p-2.5 md:grid md:grid-cols-2">
        {data.map((paymentMethod) => (
          <PaymentCard
            className="bg-color-background-base h-full w-full"
            hideText
            key={paymentMethod}
            option={paymentMethod!}
            isActive={selectedType === paymentMethod}
            onSelect={() => onSelect(paymentMethod!)}
          />
        ))}
      </div>
    </>
  );
};
